export default "__VITE_PUBLIC_ASSET__e0cd41cd__"